import type { CricketManualEventState, CricketManualScore } from '@/services/jsonDataService'

/**
 * Overs label for one team: the current over, the overs available for the
 * match, or "12.3 / 20" when both are switched on. Empty string means the
 * overs element is hidden entirely.
 */
export const oversText = (score?: CricketManualScore, eventState?: CricketManualEventState): string => {
  const parts: string[] = []
  if (eventState?.showOvers ?? true) parts.push(score?.overs ?? '')
  if (eventState?.showAvailableOvers && eventState.availableOvers !== undefined) {
    parts.push(String(eventState.availableOvers))
  }
  return parts.filter((part) => part !== '').join(' / ')
}

/** Which team rows the bug draws. Absent flags mean both, as before. */
export const teamVisibility = (eventState?: CricketManualEventState): { home: boolean; away: boolean } => {
  const home = eventState?.showTeam1 ?? true
  const away = eventState?.showTeam2 ?? true
  // A payload that hides everything would render an empty bug; keep team 1.
  return home || away ? { home, away } : { home: true, away: false }
}
